export default __webpack_public_path__ + "static/programming3-964e22ed5037872d73eaa207954b84ff.png";